import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { OptionTextComponentInReply } from '../../../../reply';
import { ReplyItem } from '../../../../../classes';

@Component({
  selector: 'option-text',
  styleUrls: ['./option-text.component.scss'],
  templateUrl: './option-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionTextComponent extends OptionTextComponentInReply {
  @Input() item: ReplyItem;
}
